/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class EnrolmentsRoute extends Route {
  queryParams = {
    jurisdiction: {
      refreshModel: true,
    },
    resource: {
      refreshModel: true,
    },
    schoolId: {
      refreshModel: true,
    },
    duration: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    // Swap duration out for a startTime timestamp for the request.
    let duration = params.duration || 15;
    params.startTime = moment().subtract(duration, 'minutes').unix();
    delete params.duration;

    let model = {
      schools: this.store.findAll('school'),
      logs: this.store.query('enrolments/log', params),
    };

    return hash(model);
  }

  afterModel(model) {
    // TODO: grab the people referenced in the logs.
    let promises = {
      logs: model.logs,
      schools: model.schools,
    };

    // pry out and returned linked resources.
    return hash(promises);
  }
}
